import { render } from "./SlideButton.vue?vue&type=template&id=0cb0d964"
import script from "./SlideButton.vue?vue&type=script&lang=js"
export * from "./SlideButton.vue?vue&type=script&lang=js"

import "./SlideButton.vue?vue&type=style&index=0&id=0cb0d964&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__